import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { addOrganizationTab, fetchOrganization } from 'redux/modules/organization';
import { formatCurrency } from '../../../helpers/util';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import { LeftNavLayout } from 'containers';
import { DataTable, ExpandableContainer, PageHeader, Spinner } from 'components';
import { getDepositVsSpendData, getPendingDraftApprovals, getFBStatus, getStripeStatus, getInvalidFacebookPages } from 'redux/modules/adminDashboard';
import moment from 'moment';
import { connect } from 'react-redux';
var AdminDashboard = (_dec = connect(function (state) {
  return {
    organization: state.organization.current,
    gettingDepositVsSpend: state.adminDashboard.gettingDepositVsSpend,
    depositVsSpendData: state.adminDashboard.depositVsSpendData,
    stripeStatus: state.adminDashboard.stripeStatus,
    gettingStripeStatus: state.adminDashboard.gettingStripeStatus,
    fbStatus: state.adminDashboard.fbStatus,
    gettingFBStatus: state.adminDashboard.gettingFBStatus,
    isFetchingInvalidFbPages: state.adminDashboard.isFetchingInvalidFbPages,
    invalidFacebookPages: state.adminDashboard.invalidFacebookPages,
    gettingPendingDraftApprovals: state.adminDashboard.gettingPendingDraftApprovals,
    pendingDraftApprovalsData: state.adminDashboard.pendingDraftApprovalsData
  };
}, {
  addOrganizationTab: addOrganizationTab,
  fetchOrganization: fetchOrganization,
  getFBStatus: getFBStatus,
  getStripeStatus: getStripeStatus,
  getDepositVsSpendData: getDepositVsSpendData,
  getInvalidFacebookPages: getInvalidFacebookPages,
  getPendingDraftApprovals: getPendingDraftApprovals
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(AdminDashboard, _Component);

  var _super = _createSuper(AdminDashboard);

  function AdminDashboard(props) {
    var _this;

    _classCallCheck(this, AdminDashboard);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleSurplusRowSelection", function (rowData) {
      _this.handleOpenTab(rowData.id, 'ads');
    });

    _defineProperty(_assertThisInitialized(_this), "handlePendingDraftsRowSelection", function (rowData) {
      _this.handleOpenTab(rowData.id, 'publishing/draft-posts');
    });

    _defineProperty(_assertThisInitialized(_this), "handleInvalidFbRowSelection", function (rowData) {
      browserHistory.push("/global/clients/".concat(rowData.organizationId));
    });

    _defineProperty(_assertThisInitialized(_this), "handleStatusRowSelection", function (rowData) {
      console.log('yo, details');
    });

    _defineProperty(_assertThisInitialized(_this), "handleStatusTimeSpanChange", function (event, index, value) {
      // attempt to show FB stats using full day
      var fbValue = value + 24 >= 48 ? value + 24 : 0;

      _this.props.getStripeStatus(value);

      _this.props.getFBStatus(fbValue);

      _this.setState({
        statusTimeSpan: value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOpenTab", function (orgId) {
      var link = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'schedule';
      return _this.props.fetchOrganization(orgId).then(function (result) {
        _this.props.addOrganizationTab(result.data);

        browserHistory.push("/org/".concat(orgId, "/").concat(link));
      })["catch"](function (err) {
        return console.error(err);
      });
    });

    _this.state = {
      statusTimeSpan: 168
    };
    return _this;
  }

  _createClass(AdminDashboard, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.getDepositVsSpendData();
      this.props.getPendingDraftApprovals();
      this.props.getStripeStatus(this.state.statusTimeSpan); // FB only reports on completed days, so last 24 hours is really yesterday
      // must pass in 48 hours to get last day

      this.props.getFBStatus(168);
      this.props.getInvalidFacebookPages();
    }
  }, {
    key: "render",
    value: function render() {
      var surplusHeaderFields = [{
        name: 'Id',
        key: 'id',
        disableSort: true
      }, {
        name: 'Name',
        key: 'name',
        disableSort: true
      }, {
        name: 'Total Deposits',
        key: 'totaldeposits',
        disableSort: true
      }, {
        name: 'Number Of Deposits',
        key: 'numdeposits',
        disableSort: true
      }, {
        name: 'Total Spent',
        key: 'totalspent',
        disableSort: true
      }, {
        name: 'Debits',
        key: 'debits',
        disableSort: true
      }, {
        name: 'Surplus',
        key: 'surplus',
        disableSort: true
      }];
      var pendingDraftFields = [{
        name: 'Organization Id',
        key: 'id',
        disableSort: true
      }, {
        name: 'Name',
        key: 'name',
        disableSort: true
      }, {
        name: 'Earliest',
        key: 'min',
        disableSort: true
      }, {
        name: 'Latest',
        key: 'max',
        disableSort: true
      }, {
        name: 'Count',
        key: 'count',
        disableSort: true
      }];
      var processStatusHeaderFields = [{
        name: 'Process',
        key: 'process_name',
        disableSort: true
      }, {
        name: 'Total',
        key: 'total_count',
        disableSort: true
      }, {
        name: 'Errors',
        key: 'error_count',
        disableSort: true
      }];
      var invalidFbPageHeaderFields = [{
        name: 'Organization Id',
        key: 'organizationId',
        disableSort: true
      }, {
        name: 'Organization Name',
        key: 'organizationName',
        disableSort: true
      }, {
        name: 'Facebook Page Name',
        key: 'username',
        disableSort: true
      }, {
        name: 'Social Account Last Updated',
        key: 'socialAccountLastUpdatedAt',
        disableSort: true
      }];
      var formattedSurplusData = this.props.depositVsSpendData.map(function (d) {
        var copy = Object.assign({}, d);
        copy.totaldeposits = formatCurrency(copy.totaldeposits);
        copy.totalspent = formatCurrency(copy.totalspent);
        copy.surplus = formatCurrency(copy.surplus);
        return copy;
      });
      var formattedStatusData = [{
        process_name: 'Stripe Webhook',
        total_count: this.props.stripeStatus.allCount.toLocaleString(),
        error_count: this.props.stripeStatus.errorCount.toLocaleString()
      }, {
        process_name: 'Facebook Calls',
        total_count: this.props.fbStatus.allCalls === 0 ? 'NA' : this.props.fbStatus.allCalls.toLocaleString(),
        error_count: this.props.fbStatus.errorCount === 0 ? 'NA' : this.props.fbStatus.errorCount.toLocaleString()
      }];
      var formattedInvalidFbPages = this.props.invalidFacebookPages.map(function (d) {
        return _objectSpread(_objectSpread({}, d), {}, {
          socialAccountLastUpdatedAt: moment(d.socialAccountLastUpdatedAt).format('LLLL')
        });
      });
      return /*#__PURE__*/React.createElement(LeftNavLayout, {
        sidebar: "admin"
      }, /*#__PURE__*/React.createElement(Helmet, {
        title: "Likeable Data Dashboard"
      }), /*#__PURE__*/React.createElement(PageHeader, {
        primary: "Likeable Local App Dashboard"
      }), /*#__PURE__*/React.createElement("div", {
        className: "container-fluid",
        style: {
          marginBottom: 36
        }
      }, /*#__PURE__*/React.createElement(ExpandableContainer, {
        height: 'auto',
        title: 'Pending Draft Approvals',
        style: {
          position: 'relative',
          marginBottom: 36
        }
      }, this.props.gettingPendingDraftApprovals && !!this.props.pendingDraftApprovalsData.length ? /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }) : /*#__PURE__*/React.createElement(DataTable, {
        firstColColored: true,
        data: this.props.pendingDraftApprovalsData,
        style: {
          margin: '0 48px'
        },
        fixedHeader: true,
        height: 500,
        headerFields: pendingDraftFields,
        onRowSelection: this.handlePendingDraftsRowSelection
      })), /*#__PURE__*/React.createElement(ExpandableContainer, {
        height: 'auto',
        title: 'Invalid Facebook Pages',
        style: {
          position: 'relative',
          marginBottom: 36
        }
      }, this.props.isFetchingInvalidFbPages ? /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }) : this.props.invalidFacebookPages.length > 0 ? /*#__PURE__*/React.createElement(DataTable, {
        firstColColored: true,
        data: formattedInvalidFbPages,
        style: {
          margin: '0 48px'
        },
        fixedHeader: true,
        height: 500,
        headerFields: invalidFbPageHeaderFields,
        onRowSelection: this.handleInvalidFbRowSelection
      }) : /*#__PURE__*/React.createElement("p", {
        style: {
          margin: '0 48px',
          padding: 20
        }
      }, "No invalid Facebook accounts found \uD83D\uDC4D")), /*#__PURE__*/React.createElement(ExpandableContainer, {
        height: 'auto',
        title: 'Health Status',
        style: {
          marginBottom: 36
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          margin: '0 48px'
        }
      }, /*#__PURE__*/React.createElement(SelectField, {
        floatingLabelText: "Time Frame*",
        value: this.state.statusTimeSpan,
        onChange: this.handleStatusTimeSpanChange
      }, /*#__PURE__*/React.createElement(MenuItem, {
        value: 1,
        primaryText: "Last Hour"
      }), /*#__PURE__*/React.createElement(MenuItem, {
        value: 4,
        primaryText: "Last 4 Hours"
      }), /*#__PURE__*/React.createElement(MenuItem, {
        value: 8,
        primaryText: "Last 8 Hours"
      }), /*#__PURE__*/React.createElement(MenuItem, {
        value: 24,
        primaryText: "Last Day"
      }), /*#__PURE__*/React.createElement(MenuItem, {
        value: 168,
        primaryText: "Last Week"
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          position: 'relative',
          minHeight: 50
        }
      }, this.props.gettingStripeStatus || this.props.gettingFBStatus ? /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }) : /*#__PURE__*/React.createElement(DataTable, {
        firstColColored: true,
        data: formattedStatusData,
        fixedHeader: true,
        height: 500,
        headerFields: processStatusHeaderFields,
        onRowSelection: this.handleStatusRowSelection
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          fontSize: 11,
          marginTop: 32,
          marginBottom: 8
        }
      }, "*Facebook Call data is only available for full days.")))));
    }
  }]);

  return AdminDashboard;
}(Component)) || _class);
export default AdminDashboard;